import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=2dcd31b6&scoped=true&lang=html"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=2dcd31b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd31b6",
  null
  
)

export default component.exports